import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmsCampaignWiseReportDawnload {
    id?: number;
    message_type: string;
    from?: string;
    to?: string;
    direction?: string;
    media_url?: string;
    message?: string;
    status?: string;
    sms_gateway_name?: string;
    retry_sms_id: number;
    error_code: string | null;
    error_message: string | null;
    createdAt: string;
    user: string | null;
}

interface SmsCampaignWiseReportState {
    smscampaignwisereportdawnlaoddata: SmsCampaignWiseReportDawnload[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface SmsCampaignWiseListParams {
    id: number;
    message_type?: string;
    from?: string;
    to?: string;
    direction?: string;
    media_url?: string;
    message?: string;
    sort?: 'ASC' | 'DESC';
    status?: string;
    limit: number;
    page: number;
    sort_field: string
    sms_gateway_name: string;
    retry_sms_id?: number;
    error_code: string;
    from_date: string;
    to_date: string;
    username: string;
    useremail: string;
    userrole: string;
    user_id: string;
}


export const GetallSmsCampaignWiseReportDawnlaod = createAsyncThunk<
    Blob,
    SmsCampaignWiseListParams,
    { rejectValue: string }
>(
    'GetallSmsCampaignWiseReportDawnlaod',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/reports/campaign-wise-reports/download/${params.id}`, {
                params: {
                    message_type: params.message_type,
                    from: params.from,
                    to: params.to,
                    direction: params.direction,
                    status: params.status,
                    sms_gateway_name: params.sms_gateway_name,
                    retry_sms_id: params.retry_sms_id,
                    error_code: params.error_code,
                    from_date: params.from_date,
                    to_date: params.to_date,
                    "user.name": params.username,
                    "user.email": params.useremail,
                    "user.role": params.userrole,
                    "user.id": params.user_id,
                    sort_field: params.sort_field,
                    sort: params.sort,
                    page: params.page,
                    limit: params.limit
                },
                responseType: 'blob' // Specify that you expect a Blob response
            });
            return response.data; // Return the Blob directly
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);



const initialState: SmsCampaignWiseReportState = {
    smscampaignwisereportdawnlaoddata: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignwisereportdawnloadSlice = createSlice({
    name: "smscampaignwisereportdawnlaod",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-sms-campaign-wise-reports-dawnlaod-slice-start============
            .addCase(GetallSmsCampaignWiseReportDawnlaod.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallSmsCampaignWiseReportDawnlaod.fulfilled, (state, action: PayloadAction<Blob>) => {
                state.loading = false;
            })
            .addCase(GetallSmsCampaignWiseReportDawnlaod.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-sms-campaign-wise-reports-dawnlaod-slice-end============      
    },
});


export default smscampaignwisereportdawnloadSlice.reducer;
